"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "usePrismicMenuBanners", {
  enumerable: true,
  get: function get() {
    return _usePrismicMenuBanners["default"];
  }
});
Object.defineProperty(exports, "fetcher", {
  enumerable: true,
  get: function get() {
    return _fetcher["default"];
  }
});
var _usePrismicMenuBanners = _interopRequireDefault(require("./usePrismicMenuBanners"));
var _fetcher = _interopRequireDefault(require("./fetcher"));